import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-shape-speech-bubble.tsx
/**
* icon.24.shape.speech-bubble
*
* Keywords: chat, message, conversation, communication, dialog, comment, text, tail
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTE2IDZhMyAzIDAgMCAxIDMgM3Y1YTMgMyAwIDAgMS0zIDNoLTIuNzY0bC00Ljc4OSAyLjM5NUExIDEgMCAwIDEgNyAxOC41di0xLjY3NUEzIDMgMCAwIDEgNSAxNFY5YTMgMyAwIDAgMSAzLTN6TTggN2wtLjIwNC4wMUEyIDIgMCAwIDAgNiA5djVsLjAxLjIwNEEyIDIgMCAwIDAgOCAxNnYyLjVsNS0yLjVoM2wuMjA0LS4wMWEyIDIgMCAwIDAgMS43ODUtMS43ODZMMTggMTRWOWEyIDIgMCAwIDAtMS43OTYtMS45OUwxNiA3eiIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=3613-8032
*/
const Icon24ShapeSpeechBubble = memo(function Icon24ShapeSpeechBubble(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M16 6a3 3 0 0 1 3 3v5a3 3 0 0 1-3 3h-2.764l-4.789 2.395A1 1 0 0 1 7 18.5v-1.675A3 3 0 0 1 5 14V9a3 3 0 0 1 3-3zM8 7l-.204.01A2 2 0 0 0 6 9v5l.01.204A2 2 0 0 0 8 16v2.5l5-2.5h3l.204-.01a2 2 0 0 0 1.785-1.786L18 14V9a2 2 0 0 0-1.796-1.99L16 7z"
		})
	});
});
//#endregion
export { Icon24ShapeSpeechBubble };

//# sourceMappingURL=icon-24-shape-speech-bubble.js.map